// Display labels + descriptions for policy statuses.
// The stored/DB values stay 'Terminated' and 'Cancelled' (do NOT change) — only the
// text shown to case managers is clarified here.
export const POLICY_STATUS_LABELS = {
  Active: 'Active',
  Pending: 'Pending',
  Terminated: 'Terminated (Marketplace/Client)',
  Cancelled: 'Cancelled – Premium Assistance',
};

export const POLICY_STATUS_DESCRIPTIONS = {
  Terminated: 'Policy was terminated by the Marketplace or by the client.',
  Cancelled:
    'Latinos Salud stopped paying the premium under the Premium Assistance program because the client did not meet the program requirements. The insurance policy itself may still be active.',
};

export const policyStatusLabel = (value) => POLICY_STATUS_LABELS[value] || value;
